var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimDenials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 25.9997H37.0006C37.7832 25.9799 38.527 25.6551 39.0734 25.0947C39.6199 24.5342 39.9257 23.7824 39.9257 22.9997C39.9257 22.2169 39.6199 21.4651 39.0734 20.9047C38.527 20.3442 37.7832 20.0195 37.0006 19.9997H35C34.2044 19.9997 33.4413 19.6836 32.8787 19.121C32.3161 18.5584 32 17.7953 32 16.9997C32 16.204 32.3161 15.441 32.8787 14.8784C33.4413 14.3157 34.2044 13.9997 35 13.9997H40.0006M36.0003 13.9997V12M36.0003 28.0003V25.9997",
    stroke: "#2CE100",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0006 6H10.0006C9.73796 5.99987 9.47782 6.0515 9.2351 6.15194C8.99238 6.25238 8.77182 6.39965 8.58603 6.58535C8.40024 6.77105 8.25286 6.99154 8.15231 7.23421C8.05175 7.47689 8 7.737 8 7.99968V42L12.68 40.0003L17.3408 42L22.0006 40.0003L26.6605 42L31.3203 40.0003L36.0003 42V36",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 22H16M23.9997 29.9997H16",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimDenials);
export default __webpack_public_path__ + "static/media/claim-denials.5f9f562ef78d71a73b057c5fc71d07b3.svg";
export { ForwardRef as ReactComponent };